import React from 'react';
import { BaseHeader } from './BaseHeader';

export const EmptyHeader = () => <BaseHeader />;
